import React, { useState, useEffect, useRef } from 'react';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import { useLang } from '@/i18n';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

const InstantProtection: React.FC = () => {
    const { t } = useLang('Delta3AirSeries.InstantProtection');
    const swiperRef = useRef<any>(null);
    const colorList = [
        {
            status: 'low',
            name: t('status1_name'),
            desc: t('status1_desc'),
        },
        {
            status: 'normal',
            name: t('status2_name'),
            desc: t('status2_desc'),
        },
        {
            status: 'high',
            name: t('status3_name'),
            desc: t('status3_desc'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 1024) {
                swiperRef.current.params.allowTouchMove = true;
            } else {
                swiperRef.current.params.allowTouchMove = false;
            }
        }
    }, []);

    return (
        <section className={`${styles.InstantProtection} GtmModuleData-section`} id="D3A-InstantProtection" data-section-id={'D3A-InstantProtection'}>
            <div className="color-list">
                {colorList.map((item, i: number) => (
                    <div className="status-item" key={i}>
                        <div className={`status-color ${item.status}`}></div>
                        <div className="status-name">{item.name}</div>
                        <div className="status-desc">{item.desc}</div>
                    </div>
                ))}
            </div>
            <div className="tips">{t('tips')}</div>
            <div className="content">
                <div className="indicator-title">{t('title')}</div>
                <div className="indicator-content">
                    <Swiper
                        modules={[Navigation, Pagination]}
                        pagination
                        slidesPerView={'auto'}
                        className="indicator-content-swiper"
                        spaceBetween={16}
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                    >
                        <SwiperSlide className="item-card-slide">
                            <div className="item-card">
                                <EcoImg
                                    pc="https://websiteoss.ecoflow.com/upload/image/1763113213556/in-1.jpg"
                                    pad="https://websiteoss.ecoflow.com/upload/image/1763360867747/indicator-m-kv1.jpg"
                                    h5="https://websiteoss.ecoflow.com/upload/image/1763360867747/indicator-m-kv1.jpg"
                                ></EcoImg>
                                <div className="item-filter">
                                    <div className="item-title">{t('item1_title')}</div>
                                    <div className="item-desc">{t('item1_desc')}</div>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide className="item-card-slide">
                            <div className="item-card">
                                <EcoImg
                                    pc="https://websiteoss.ecoflow.com/upload/image/1763113213765/in-2.jpg"
                                    pad="https://websiteoss.ecoflow.com/upload/image/1763360867963/indicator-m-kv2.jpg"
                                    h5="https://websiteoss.ecoflow.com/upload/image/1763360867963/indicator-m-kv2.jpg"
                                ></EcoImg>
                                <div className="item-filter">
                                    <div className="item-title">{t('item2_title')}</div>
                                    <div className="item-desc">{t('item2_desc')}</div>
                                </div>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </section>
    );
};

export default InstantProtection;
